import { Box } from '@mui/material'
import Logger from 'services/Logger'
import { EventNote } from 'types/api/changes'

/**
 * Returns the cover image note (Type === '1' with FileBytes) from the notes array.
 */
export function getCoverImageNote(notes?: EventNote[]): EventNote | undefined {
  Logger.blue('EventCoverImage', 'Getting cover image note from notes', notes)
  if (!notes || typeof notes === 'string') return undefined
  return notes.find((note) => note.NoteType === '1' && note.FileBytes)
}

interface EventCoverImageProps {
  notes?: EventNote[]
}

/**
 * Renders the event cover image banner at the top of the popup.
 * This is positioned absolutely behind the EventPopupHead content.
 */
export default function EventCoverImage({ notes }: EventCoverImageProps) {
  const coverNote = getCoverImageNote(notes)

  if (!coverNote?.FileBytes) return null

  const imageData = coverNote.FileBytes.startsWith('data:')
    ? coverNote.FileBytes
    : `data:image/jpeg;base64,${coverNote.FileBytes}`

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 0,
        overflow: 'hidden'
      }}
    >
      <img
        src={imageData}
        alt="Cover"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover'
        }}
      />
      {/* Gradient overlay for readability - stronger at bottom */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background:
            'linear-gradient(to bottom, rgba(0,0,0,0) 0%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0.6) 100%)'
        }}
      />
    </Box>
  )
}
